// extracted by mini-css-extract-plugin
export var grid = "_d-5";
export var layout = "_d-0";
export var leftColumn = "_d-1";
export var leftInner = "_d-2";
export var rightColumn = "_d-3";
export var rightInner = "_d-4";